import * as Account from './Account';
import * as Agency from './Agency';
import * as Auth from './Auth';
import * as Billing from './billing';
import * as Weebly from './weebly';

export const login = Auth.login;
export const generateImpersonateToken = Auth.generateImpersonateToken;
export const refreshToken = Auth.refreshToken;
export const forgotPassword = Auth.forgotPassword;
export const resetPassword = Auth.resetPassword;
export const resendRegisterConfirmation = Account.resendRegisterConfirmation;
export const registerContributor = Auth.registerContributor;
export const addVoucher = Auth.addVoucher;
export const getGoogleImporterAuthUrl = Auth.getGoogleImporterAuthUrl;
export const getGoogleImporterViews = Auth.getGoogleImporterViews;
export const startGoogleImporter = Auth.startGoogleImporter;
export const getGoogleImporterProgress = Auth.getGoogleImporterProgress;

export const confirmUpdateEmail = Account.confirmUpdateEmail;
export const resetEmail = Account.resetEmail;
export const deleteAccount = Account.deleteAccount;
export const acceptContributorRole = Account.acceptContributorRole;
export const rejectContributorRole = Account.rejectContributorRole;
export const createWebsiteForMigration = Account.createWebsiteForMigration;
export const createNewUserForMigration = Account.createNewUserForMigration;
export const getVouchersInfo = Account.getVouchersInfo;
export const getUpdatePaymentMethodUrl = Billing.getUpdatePaymentMethodUrl;
export const getPaymentAuthToken = Billing.getPaymentAuthToken;
export const getCustomer = Billing.getCustomer;
export const getPaymentMethod = Billing.getPaymentMethod;
export const getPaymentPlans = Billing.getPaymentPlans;
export const getAllSubscriptions = Billing.getAllSubscriptions;
export const generateInvoice = Billing.generateInvoice;
export const getComputedSubscriptionPrice = Billing.getComputedSubscriptionPrice;
export const createCustomer = Billing.createCustomer;
export const createPaymentMethod = Billing.createPaymentMethod;
export const cancelSubscription = Billing.cancelSubscription;
export const cancelSubscriptionImmediate = Billing.cancelSubscriptionImmediate;
export const reactivateSubscription = Billing.reactivateSubscription;
export const updateCustomer = Billing.updateCustomer;
export const validatePromoCode = Billing.validatePromoCode;
export const getAgencyCustomer = Billing.getAgencyCustomer;

export const weeblyLogin = Weebly.weeblyLogin;
export const weeblySync = Weebly.weeblySync;

export const getAgencyUi = Agency.getAgencyUi;
export const changeWebsiteWhiteLabelStatus = Agency.changeWebsiteWhiteLabelStatus;
export const getAgencyQuaterlyCommission = Agency.getAgencyQuaterlyCommission;
